module.exports = __webpack_public_path__ + "ai-bot-tag-TAwp060102f620b71348f1f86fd5da0e79fc.png";